import { TableHead, TableRow, TableCell } from '@mui/material'
import { useTranslation } from 'react-i18next'

export type ManualHoursReportingTableHeadProps = {
  showUserColumn: boolean
  showExportedColumn: boolean
}

export const ManualHoursReportingTableHead = ({
  showUserColumn,
  showExportedColumn,
}: ManualHoursReportingTableHeadProps): JSX.Element => {
  const { t } = useTranslation('manualHoursReporting')

  const columnNames = [
    'id',
    ...(showUserColumn ? (['user'] as const) : []),
    'date',
    'amountMinutes',
    'created',
    'updated',
    ...(showExportedColumn ? (['exported'] as const) : []),
    'status',
  ]

  return (
    <TableHead sx={{ borderRadius: 8 }}>
      <TableRow>
        {columnNames.map((columnName) => (
          <TableCell key={columnName}>
            {t(`columnNames.${columnName}`)}
          </TableCell>
        ))}
        <TableCell />
      </TableRow>
    </TableHead>
  )
}
